import React, { useEffect, useState } from "react";
import { getRequest } from "../../services/api";
import DataTable from "../table/DataTable";
import { formatAppDate } from "../../helpers/date-formatter";

function SentPushNotificationList({ onUseNotification }) {
  const [pushNotifications, setPushNotifications] = useState([]);

  useEffect(() => {
    getPushNotifications();
  }, []);

  const getPushNotifications = async () => {
    const data = await getRequest("admin/push-notification", true);
    setPushNotifications(data);
  };

  const columns = [
    {
      key: "title",
      label: "Title",
      render: (notification) => (
        <span className="font-semibold">{notification.title}</span>
      ),
    },
    {
      key: "message",
      label: "Message",
      render: (notification) => <span>{notification.message}</span>,
    },
    {
      key: "platform",
      label: "Platform",
      render: (notification) => <span>{notification.platform}</span>,
    },
    {
      key: "topic",
      label: "Topic",
      render: (notification) => <span>{notification.topic}</span>,
    },
    {
      key: "sentOn",
      label: "Sent On",
      width: "160px",
      render: (notification) => formatAppDate(notification.sentOn),
    },
    {
      key: "actions",
      label: "Actions",
      width: "120px",
      render: (notification) => (
        <button
          className="text-primary hover:text-primary-dark"
          onClick={() => onUseNotification(notification)}
        >
          Use
        </button>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={pushNotifications}
      rowKey="id"
      minWidth="760px"
      emptyMessage="No push notifications found."
    />
  );
}

export default SentPushNotificationList;
